import type { WorkspaceRole } from "@veritrellis/shared/roles";
import { workspaceRoleRank } from "@veritrellis/shared/roles";
import { useAdminMe } from "./useAdminMe.js";

export const roleAtLeast = (role: WorkspaceRole | null, minimum: WorkspaceRole): boolean => {
  if (role === null) {
    return false;
  }
  return workspaceRoleRank[role] >= workspaceRoleRank[minimum];
};

export const useCurrentRole = (): { role: WorkspaceRole | null; isLoading: boolean } => {
  const q = useAdminMe();
  const activeId = q.data?.activeWorkspaceId ?? null;
  if (activeId === null) {
    return { role: null, isLoading: q.isLoading };
  }
  const ws = q.data?.workspaces.find((w) => w.id === activeId) ?? null;
  return { role: ws?.role ?? null, isLoading: q.isLoading };
};
